import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { useT } from '../i18n';
import { Button } from './ui/button';

/*
  Ops panel, Telegram alerts: "Find topics" (GET /api/admin/alerting/topics) —
  the forum topics the bot has seen, and which topic ids exist or are blocked,
  so the right id can be typed into the topic field. Platform admins only.
*/
export default function AlertTopics({ onPick }) {
  const { t } = useT();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    setError('');
    try {
      const r = await axios.get(API + '/admin/alerting/topics');
      setData(r.data || {});
    } catch (e) {
      setError((e && e.response && e.response.data && e.response.data.detail) || t('Could not load the topics'));
    } finally {
      setBusy(false);
    }
  };

  const topics = (data && Array.isArray(data.topics) && data.topics) || [];
  const ok = (data && Array.isArray(data.ok_ids) && data.ok_ids) || [];

  return (
    <div className="space-y-2" data-testid="alert-topics">
      <Button size="sm" variant="outline" onClick={load} disabled={busy} data-testid="alert-topics-load">
        {t('Find topics')}
      </Button>
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
      {data ? (
        <div className="text-xs space-y-1">
          {topics.length ? (
            <ul className="space-y-1">
              {topics.map((x) => (
                <li key={String(x.id)}>
                  <button type="button" className="underline" onClick={() => onPick && onPick(String(x.id))}>
                    {x.id} — {x.name || '—'}
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-muted-foreground">{t('The bot has not seen topic names (privacy mode). Topic ids that exist:')} {ok.join(', ') || '—'}</p>
          )}
        </div>
      ) : null}
    </div>
  );
}
